import "./AssignLabToTestEditComponent.scss";
import SearchComponent from "../../../../../shared/components/search/SearchComponent";
import TabsWrapperComponent, {
    TabComponent,
    TabContentComponent,
    TabsComponent
} from "../../../../../shared/components/tabs/tabsComponent";
import CheckBoxComponent from "../../../../../shared/components/core/checkbox/CheckboxComponent";
import commonService from "../../../../../shared/services/common.service";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import React, {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../../../shared/services";
import {IAPIResponseType} from "../../../../../shared/models/api.model";
import DrawerComponent from "../../../../../shared/components/drawer/drawerComponent";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import LottieFileGenarationComponent
    from "../../../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import {ImageConfig} from "../../../../../constants";

interface AssignLabToTestEditComponentProps {
    testId: string;
    assignedLabs: any
    onUpdateComplete: Function;
    onEditCancel: Function;
}

const AssignLabToTestEditComponent = (props: AssignLabToTestEditComponentProps) => {
    const {testId, assignedLabs, onUpdateComplete, onEditCancel} = props;

    const [selectedLabIds, setSelectedLabIds] = React.useState<any>([]);
    const [labDetails, setLabDetails] = useState<any>(undefined);
    const [isLabDetailsLoading, setIsLabDetailsLoading] = useState<boolean>(false);
    const [isLabDetailsDrawerOpen, setIsLabDetailsDrawerOpen] = useState<boolean>(false);
    const [isLabListLoading, setIsLabListLoading] = useState<boolean>(false);
    const [labsList, setLabsList] = useState<any>([]);
    const [searchText, setSearchText] = useState<string>('');
    const [isLabsIsGettingAssigned, setIsLabsIsGettingAssigned] = useState<boolean>(false);
    const handleSearch = (value: any) => {
        setSearchText(value);
    }

    const getLabDetails = useCallback((labID: string) => {
        const payload = {};
        setIsLabDetailsLoading(true);
        CommonService._lab.getLabDetails(labID, payload)
            .then((response: IAPIResponseType<any>) => {
                setLabDetails(response?.data);
                setIsLabDetailsLoading(false);
            })
            .catch((error: any) => {
                setIsLabDetailsLoading(false);
                setLabDetails(labDetails);
            });
    }, [labDetails]);

    const getLabListLite = useCallback((searchText: string) => {
        const payload = {
            search: searchText
        };
        setIsLabListLoading(true);
        CommonService._lab.getLabListLite(payload)
            .then((response: IAPIResponseType<any>) => {
                setLabsList(response?.data);
                setIsLabListLoading(false);
            })
            .catch((error: any) => {
                setIsLabListLoading(false);
                setLabsList([]);
            });
    }, []);

    useEffect(() => {
        getLabListLite(searchText);
    }, [searchText,getLabListLite]);

    const handleViewLabDetails = useCallback((labId: any) => {
        setLabDetails(undefined);
        getLabDetails(labId);
        setIsLabDetailsDrawerOpen(true);
    }, [getLabDetails]);

    const handleAssignLab = useCallback(() => {
        const payload = {
            testId: testId,
            labIds: selectedLabIds
        }
        setIsLabsIsGettingAssigned(true);
        commonService._test.assignLabsToTest(payload)
            .then((response: IAPIResponseType<any>) => {
                setIsLabsIsGettingAssigned(false);
                onUpdateComplete(labsList?.filter((lab: any) => selectedLabIds?.includes(lab?.id)))
            })
            .catch((error: any) => {
                setIsLabsIsGettingAssigned(false);
            });
    }, [selectedLabIds, testId, labsList,onUpdateComplete]);

    useEffect(() => {
        if(assignedLabs?.length > 0){
            setSelectedLabIds(assignedLabs?.map((lab:any)=> lab?.id))
        }
    }, [assignedLabs]);

    return (
        <div className={'assign-lab-to-test-edit-component'}>
            {/* eslint-disable-next-line no-script-url */}
            <form noValidate={true} action={'javascript:void'}>
                <div className="t-form-controls-wrapper pdd-top-5 assign-lab-to-test-tab">
                    <SearchComponent
                        label={"Search Lab"}
                        id="search_input"
                        placeholder={"Search by Lab name"}
                        value={searchText}
                        onChange={handleSearch}
                    />
                    <TabsWrapperComponent>
                        <TabsComponent
                            allowScrollButtonsMobile={false}
                            variant={"fullWidth"}
                        >
                            <TabComponent label="LABS" value={'labs'}/>
                        </TabsComponent>
                        <TabContentComponent
                            selectedTab={"labs"} value={"labs"}
                        >
                            {
                                isLabListLoading ?
                                    <div className={'table-loader-container'}>
                                        <LottieFileGenarationComponent
                                            loop={true}
                                            autoplay={true}
                                            animationData={ImageConfig.LoadingLottieFile} />

                                    </div> :
                                    labsList?.length > 0 ?
                                        <div>
                                            {
                                                labsList?.map((lab: any, index: number) => {
                                                    return (
                                                        <div key={index} className={'lab-list-item'}>
                                                            <div className={'lab-list-item-name-and-selection'}>
                                                                <CheckBoxComponent
                                                                    checked={selectedLabIds.includes(lab.id)}
                                                                    onUpdate={(isChecked: boolean) => {
                                                                        if (isChecked) {
                                                                            setSelectedLabIds([...selectedLabIds, lab.id]);
                                                                        } else {
                                                                            setSelectedLabIds(selectedLabIds.filter((id: any) => id !== lab.id));
                                                                        }
                                                                    }}
                                                                    name={commonService.capitalizeFirstLetterOfEachWord(lab.name)}
                                                                />
                                                                <div className={'lab-list-item-name'}>
                                                                    {commonService.capitalizeFirstLetterOfEachWord(lab.name)}
                                                                </div>
                                                            </div>
                                                            <div className={'lab-list-item__action'}>
                                                                <div className={'underline-button'} onClick={() => {
                                                                    handleViewLabDetails(lab.id);
                                                                }}>
                                                                    View Details
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div> :
                                        <div>
                                            No Labs Found
                                        </div>
                            }
                        </TabContentComponent>
                    </TabsWrapperComponent>
                </div>
                <div className='form-action-section-edit'>
                    <ButtonComponent
                        className={"width-25"}
                        color={"secondary"}
                        type={"button"}
                        variant={"outlined"}
                        fullWidth={false}
                        handleClick={() => {
                            onEditCancel()
                        }}
                    >
                        Cancel
                    </ButtonComponent>
                    <ButtonComponent
                        className="width-25"
                        type="button"
                        color={"primary"}
                        variant={"contained"}
                        fullWidth={false}
                        isLoading={isLabsIsGettingAssigned}
                        handleClick={handleAssignLab}
                    >
                        Save
                    </ButtonComponent>
                </div>
            </form>

            <DrawerComponent
                title={'Lab Details'}
                open={isLabDetailsDrawerOpen}
                onClose={() => {
                    setIsLabDetailsDrawerOpen(false);
                }}
            >
                <div className={'view-details-drawer'}>
                    {
                        isLabDetailsLoading ?
                            <div className={'lab-details-drawer__loading'}>
                                Loading...
                            </div> :
                            <div>
                                {
                                    labDetails ?
                                        <div>
                                            <DetailsDataKeyValueComponent title={'Lab Name:'} isHorizontal={true}>
                                                {labDetails?.name ? commonService.capitalizeFirstLetterOfEachWord(labDetails?.name) : 'N/A'}
                                            </DetailsDataKeyValueComponent>
                                            <DetailsDataKeyValueComponent isHorizontal={true} title={'Lab ID:'}>
                                                {labDetails?.id || 'N/A'}
                                            </DetailsDataKeyValueComponent>
                                            <DetailsDataKeyValueComponent
                                                isHorizontal={true}
                                                title={"CAP ID:"}> {labDetails?.capId || 'N/A'} </DetailsDataKeyValueComponent>
                                            <DetailsDataKeyValueComponent
                                                isHorizontal={true}
                                                title={"Lab Type:"}> {CommonService.mapLabTypeToName(labDetails?.labType) || 'N/A'}
                                            </DetailsDataKeyValueComponent>
                                            <div className={'horizontal-line'}></div>
                                            <DetailsDataKeyValueComponent
                                                isHorizontal={true}
                                                title={"Email ID:"}> {labDetails?.emailId || 'N/A'} </DetailsDataKeyValueComponent>
                                            <DetailsDataKeyValueComponent
                                                isHorizontal={true}
                                                title={"Mobile Number:"}> {CommonService.getMaskedMobileNumber(labDetails?.mobileNumber) || 'N/A'} </DetailsDataKeyValueComponent>
                                            <div className={'horizontal-line'}></div>
                                            <DetailsDataKeyValueComponent
                                                isHorizontal={true}
                                                title={"Address Line 1:"}> {labDetails?.addressLine1 || 'N/A'} </DetailsDataKeyValueComponent>
                                            <DetailsDataKeyValueComponent
                                                isHorizontal={true}
                                                title={"Address Line 2:"}> {labDetails?.addressLine2 || 'N/A'} </DetailsDataKeyValueComponent>
                                            <DetailsDataKeyValueComponent
                                                isHorizontal={true}
                                                title={"ZIP Code:"}> {labDetails?.zipcode || 'N/A'} </DetailsDataKeyValueComponent>
                                            <DetailsDataKeyValueComponent
                                                isHorizontal={true}
                                                title={"State:"}> {labDetails?.state || 'N/A'} </DetailsDataKeyValueComponent>
                                            <DetailsDataKeyValueComponent
                                                isHorizontal={true}
                                                title={"City:"}> {labDetails?.city || 'N/A'} </DetailsDataKeyValueComponent>
                                        </div> :
                                        <div>
                                            No Details Found
                                        </div>
                                }
                            </div>
                    }
                </div>
            </DrawerComponent>
        </div>
    );

};

export default AssignLabToTestEditComponent;